import DashboardContainer from "../../Containers/Dashboard";
import SupplierDashboardContainer from "../../Containers/SupplierDashboard";

// The /dashboard route is shared by both roles; render the matching dashboard.
const Dashboard = () => {
  const isCommunityManagementRole =
    localStorage.getItem("isCommunityManagementRole") === "true";

  return isCommunityManagementRole ? (
    <DashboardContainer />
  ) : (
    <SupplierDashboardContainer />
  );
};

export default Dashboard;
